import { Theme } from "@emotion/react";
import { SxProps } from "@mui/system";
import { minHeightDvh } from "../../theme/mixins";

// The shell fills the screen so the footer sits at the bottom of a short page rather than
// half way up it. `dvh` and not `vh`: with `vh` this is as tall as the viewport *would* be
// with the browser chrome retracted, so on a phone every page started a little scrolled.
export const layoutContainerStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    ...minHeightDvh('100dvh'),
    /*
     * Absorbs the scrollbar gutter that `fullBleed` cannot see.
     *
     * A full-bleed band is `100vw` wide, and `100vw` counts the classic scrollbar while the
     * space it has to fit into does not -- so on any platform that reserves a scrollbar
     * (a desktop or tablet browser, but not a phone, whose scrollbar is an overlay) every
     * band hung ~7px past each edge and gave the whole page a horizontal scroll. Nothing is
     * lost by clipping it: those 7px are the gutter, not content.
     *
     * `clip` and emphatically not `hidden`. `overflow-x: hidden` forces the other axis to
     * `auto`, making this a scroll container -- which would break the `position: sticky`
     * editor bars on About and Our Services, and re-home the page's own scrolling. `clip`
     * clips without creating one. Where it is unsupported the declaration is dropped and
     * the layout is simply as it was.
     */
    overflowX: 'clip',
};

// The page scrolls naturally rather than inside a fixed-height box — that keeps
// the theme's `scroll-behavior: smooth` meaningful and lets hero/CTA bands run
// full-bleed via the `fullBleed` mixin.
export const containerStyles: SxProps<Theme> = {
    flexGrow: 1,
    py: { xs: 3, md: 4 },
};
